export default {"src":"/_next/static/media/error.cb9eab79.svg","height":800,"width":800};